<template>
    <BreadCrumb PageTitle="Etas des emplacements" />
    <ListeUsagerEmplacementDetail/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeUsagerEmplacementDetail from "../../components/Emplacement/ListeUsagerEmplacementDetail.vue";
    export default defineComponent({
      name: "ListeUsagerEmplacementDetailPage",
      components: {
        BreadCrumb,
        ListeUsagerEmplacementDetail,
      },
    });
  </script>